import { ALL_USERS_ID } from "../constants.js";
import { getTHERMSImageThumbnailUrl } from "../../Files/utils/get-therms-image-thumbnail-url.js";
import { useCurrentUser } from "../../AuthWrapper2/hooks/useCurrentUser.js";
import { useUserName } from "../hooks/useUserName.js";
import "react";
import { Avatar } from "@therms/atalaya";
import { Fragment as Fragment$1, jsx, jsxs } from "react/jsx-runtime";
import classnames from "classnames";
// src/modules/Users/shared/UserName.tsx
var Render = ({ avatarSize, avatarUrl, displayName, idNumber, showId = true, truncate }) => {
	const idTag = /* @__PURE__ */ jsx("span", {
		className: "bg-border rounded px-[2px] text-xs font-medium",
		children: idNumber
	});
	if (avatarUrl) return /* @__PURE__ */ jsxs("span", {
		className: classnames({ truncate }, "space-x-xs inline-flex items-center"),
		children: [
			/* @__PURE__ */ jsx(Avatar, {
				url: getTHERMSImageThumbnailUrl(avatarUrl),
				circular: true,
				size: avatarSize || "xs"
			}),
			/* @__PURE__ */ jsx("span", {
				className: classnames({ "line-clamp-1": truncate }),
				children: displayName
			}),
			showId && !!idNumber && /* @__PURE__ */ jsxs(Fragment$1, { children: [" ", idTag] })
		]
	});
	return /* @__PURE__ */ jsxs("span", {
		className: classnames({ "line-clamp-1": truncate }),
		children: [displayName, showId && !!idNumber && /* @__PURE__ */ jsxs(Fragment$1, { children: [" ", idTag] })]
	});
};
var UserNameFromId = ({ avatar, avatarSize, showId, truncate, userId }) => {
	const allUsers = userId === ALL_USERS_ID;
	const { data, loading } = useUserName({ userId }, {
		cacheStrategy: "cache-only",
		fire: !allUsers
	});
	if (allUsers) return /* @__PURE__ */ jsx("span", { children: "All Users" });
	if (data?.user) return /* @__PURE__ */ jsx(Render, {
		avatarUrl: avatar ? data.user.avatarUrl : "",
		avatarSize,
		idNumber: data.user.idNumber,
		displayName: data.user.displayName,
		showId,
		truncate
	});
	return null;
};
var UserName = ({ avatar, avatarSize, showId, truncate, user, userId }) => {
	if (user) return /* @__PURE__ */ jsx(Render, {
		avatarUrl: avatar ? user.avatarUrl : "",
		avatarSize,
		idNumber: user.idNumber,
		showId,
		displayName: user.displayName,
		truncate
	});
	if (userId) return /* @__PURE__ */ jsx(UserNameFromId, {
		avatar,
		avatarSize,
		showId,
		truncate,
		userId
	});
	return null;
};
var CurrentUserName = (props) => {
	const { id } = useCurrentUser();
	return /* @__PURE__ */ jsx(UserNameFromId, {
		avatar: props.avatar,
		avatarSize: props.avatarSize,
		truncate: props.truncate,
		userId: id
	});
};
export { CurrentUserName, UserName };

//# sourceMappingURL=UserName.js.map